import { Button, Space, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconCalendarCancel } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { primaryColor } from '../../../../constants/theme';
import { NoAvailabilityNotifyButton } from './NoAvailabilityNotifyButton';

interface NoAvailabilitySetProps {
  professionalId: string;
}


export const NoAvailabilitySet = (
  {
    professionalId
  }: NoAvailabilitySetProps
) => {
  const navigate = useNavigate();

  return (
    <Stack
      align="center"
      justify="center"
      py={100}
      gap={10}
      data-testid="no-availability-set"
    >
      <ThemeIcon
        size={80}
        radius="100%"
        variant="light"
        color={primaryColor}
        data-testid="no-availability-icon"
      >
        <IconCalendarCancel size={40} />
      </ThemeIcon>
      <Title
        order={4}
        fw="normal"
        c="dimmed"
        ta="center"
        data-testid="no-availability-title"
      >
        More time coming soon.
      </Title>
      <Text c="dimmed" data-testid="no-availability-description">
        Tap "Notify Me" and we will email you when new time slots are available.
      </Text>
      <Space h="md" />
      <NoAvailabilityNotifyButton professionalId={professionalId} />
      <Button
        color={primaryColor}
        data-testid="no-availability-back-button"
        onClick={() => navigate(-1)}
        maw={400}
        fullWidth
        variant="outline"
      >
        Keep Exploring
      </Button>

    </Stack>
  );
};
